if (!customElements.get('cart-lifetime-upsell')) {
  customElements.define(
    'cart-lifetime-upsell',
    class CartLifetimeUpsell extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;

        this.toggle = this.querySelector('[data-lifetime-toggle]');
        this.error = this.querySelector('[data-lifetime-error]');
        this.variantId = Number(this.dataset.variantId);
        this.lineKey = this.dataset.lineKey || '';
        this.inCart = this.dataset.inCart === 'true';
        this.storageKey = `scLifetimeOptOut:${this.dataset.cartToken || 'cart'}`;

        if (!this.toggle || !this.variantId) return;
        this.toggle.checked = this.inCart;
        this.toggle.addEventListener('change', () => this.onToggle());

        if (!this.inCart && sessionStorage.getItem(this.storageKey) !== '1') {
          this.toggle.checked = true;
          this.add();
        }
      }

      onToggle() {
        if (this.toggle.checked) {
          sessionStorage.removeItem(this.storageKey);
          if (!this.inCart) this.add();
        } else {
          sessionStorage.setItem(this.storageKey, '1');
          if (this.inCart) this.remove();
        }
      }

      setLoading(loading) {
        this.classList.toggle('is-loading', loading);
        this.toggle.disabled = loading;
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message || '';
        this.error.hidden = !message;
      }

      request(url, payload) {
        this.setLoading(true);
        this.showError('');

        const body = {
          ...payload,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        };

        return fetch(url, {
          ...fetchConfig('javascript'),
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) throw new Error(state.description || state.message || 'Unable to update the cart.');
            const drawer = document.querySelector('cart-drawer');
            if (drawer && state.sections) drawer.renderContents(state);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'lifetime-updates',
                productVariantId: this.variantId,
                cartData: state,
              });
            }
            return state;
          })
          .catch((error) => {
            this.showError(error.message || 'Unable to update the cart.');
            this.toggle.checked = this.inCart;
          })
          .finally(() => this.setLoading(false));
      }

      add() {
        if (this.inCart) return Promise.resolve();
        return this.request(routes.cart_add_url, {
          items: [{ id: this.variantId, quantity: 1, properties: { '_cart_upsell': 'Lifetime Updates' } }],
        });
      }

      remove() {
        if (!this.inCart || !this.lineKey) return Promise.resolve();
        return this.request(routes.cart_change_url, { id: this.lineKey, quantity: 0 });
      }
    },
  );
}
